module.exports = __webpack_public_path__ + "static/media/book4.72d6ec64.jpg";